import { GameId } from "./GameIds";

export enum GameType {
    Unity = "unity",
    React = "React"
}

export enum LaunchStatus {
  UNANNOUNCED = "unannounced", // Does not appear in more games section, does not show coming soon modal in prod
  ANNOUNCED = "announced", // Appears in more games with "coming soon" text, shows coming soon modal in prod
  RELEASED = "released" // Appears in more games with description, fully playable in prod
}

export interface GameMetadata {
  gameId: string;
  gameName: string;
  gameDescription: string;
  gameURL: string;
  gameType: GameType;
  launchStatus: LaunchStatus; // Controls game visibility and availability
  gameIcon?: string; // Icon URL for emails and UI
}
  
// Metadata
export const GAME_METADATAS: Record<GameId, GameMetadata> = {
    [GameId.TileClicker]: {
      gameId: GameId.TileClicker,
      gameURL: "https://tileclicker.com",
      gameType: GameType.Unity,
      launchStatus: LaunchStatus.RELEASED,
      gameName: "Tile Clicker",
      gameDescription: "Find a path through the maze that includes every tile once.",
      gameIcon: "https://tileclicker.com/icon-192.png",
    },
    [GameId.BanterBattle]: {
      gameId: GameId.BanterBattle,
      gameURL: "https://banterbattle.com",
      gameType: GameType.React,
      launchStatus: LaunchStatus.ANNOUNCED,
      gameName: "Banter Battle",
      gameDescription: "Reddit meets Quiplash. Vote on the world's wittiest answers and submit your own.",
      gameIcon: "https://banterbattle.com/icon-192.png",
    },
    [GameId.Taptionary]: {
      gameId: GameId.Taptionary,
      gameURL: "https://taptionary.com",
      gameType: GameType.React,
      launchStatus: LaunchStatus.RELEASED,
      gameName: "Taptionary",
      gameDescription: "Get from one word to another by tapping through the dictionary.",
      gameIcon: "https://taptionary.com/icon-192.png",
    },
    [GameId.GrowGrowTomato]: {
      gameId: GameId.GrowGrowTomato,
      gameURL: "https://growgrowtomato.netlify.app",
      gameType: GameType.React,
      launchStatus: LaunchStatus.UNANNOUNCED,
      gameName: "Grow Grow Tomato",
      gameDescription: "A calm, Pomodoro-based farming game where your focus grows tomatoes.",
      gameIcon: "https://growgrowtomato.netlify.app/icon-192.png",
    },
    [GameId.Craftegory]: {
      gameId: GameId.Craftegory,
      gameURL: "https://craftegory.netlify.app",
      gameType: GameType.React,
      launchStatus: LaunchStatus.UNANNOUNCED,
      gameName: "Craftegory",
      gameDescription: "Combine terms to unlock hidden constellations. A new theme every day!",
      gameIcon: "https://craftegory.netlify.app/icon-192.png",
    },
    [GameId.AnalogyAscent]: {
      gameId: GameId.AnalogyAscent,
      gameURL: "https://analogyascent.com",
      gameType: GameType.React,
      launchStatus: LaunchStatus.RELEASED,
      gameName: "Analogy Ascent",
      gameDescription: "Complete the analogy: A is to B what C is to ___. 15 rounds, 3 tiers of difficulty.",
      gameIcon: "https://analogyascent.com/icon-192.png",
    },
  }